import { By } from 'selenium-webdriver';
import { DriverLike, register } from '@oracle/oraclejet-webdriver';
import { InputSensitiveTextWebElement } from './InputSensitiveTextWebElement';
export { InputSensitiveTextWebElement };

/**
 * Retrieve an instance of [InputSensitiveTextWebElement](../classes/InputSensitiveTextWebElement.html).
 * @example
 * ```javascript
 * import { findInputSensitiveText } from '@oracle/oraclejet-core-pack/webdriver';
 * const el = await findInputSensitiveText(driver, By.id('my-oj-c-input-sensitive-text'));
 * ```
 * @param driver A WebDriver/WebElement instance from where the element will be
 * searched. If WebDriver is passed, the element will be searched globally in the
 * document. If WebElement is passed, the search will be relative to this element.
 * @param by The locator with which to find the element
 */
export async function findInputSensitiveText(
  driver: DriverLike,
  by: By
): Promise<InputSensitiveTextWebElement> {
  const webEl = await driver.findElement(by);
  // Check that the element is of type InputSensitiveTextWebElement
  if (!(webEl instanceof InputSensitiveTextWebElement)) {
    const tagName = await webEl.getTagName();
    let supplemental = '';
    if (webEl.constructor.name === 'InputSensitiveTextWebElement') {
      supplemental = 'You likely have multiple installations of this package.';
    }
    throw Error(
      `findInputSensitiveText(${by}) created ${webEl.constructor.name} for <${tagName}>, but expected ${InputSensitiveTextWebElement.name}. ${supplemental}`
    );
  }
  return webEl;
}

register('oj-c-input-sensitive-text', InputSensitiveTextWebElement);
